






import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class InputLabel extends Vue {

}
